var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M14.7096 29.2777C10.8682 29.2777 7.25623 27.7804 4.54109 25.0664C-1.06578 19.4595 -1.06578 10.3368 4.54109 4.72933C10.148 -0.877549 19.2707 -0.877549 24.8776 4.72933C27.5939 7.44447 29.0889 11.057 29.0889 14.8979C29.0889 18.7393 27.5939 22.3501 24.8776 25.0664C22.1625 27.7804 18.5511 29.2777 14.7096 29.2777ZM14.7096 4.62175C12.0762 4.62175 9.44445 5.62381 7.43974 7.62737C3.43261 11.6368 3.43261 18.1583 7.43974 22.1666C9.38117 24.108 11.9634 25.178 14.7096 25.178C17.4558 25.178 20.037 24.108 21.979 22.1666C23.9204 20.2252 24.9898 17.644 24.9898 14.8973C24.9898 12.1511 23.921 9.56881 21.979 7.62737C19.9754 5.62381 17.3419 4.62175 14.7096 4.62175Z",
    fill: "url(#paint0_linear_740_10572)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_10572",
    x1: 6.98846,
    y1: 16.7812,
    x2: 28.8823,
    y2: 16.7759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCircle);
export default __webpack_public_path__ + "static/media/small-circle.cf0029d5b99df248110628a4274d8482.svg";
export { ForwardRef as ReactComponent };